<app-spinner-overlay></app-spinner-overlay>
<div class="contenitore">
  <div class="titolo-pagina">
    <app-titolo-subtitolo
      titolo="Materialità"
      subTitolo="Effettua l'analisi di materialità attraverso un processo interamente digitalizzato ed in linea con gli standard di reportistica internazionale di sostenibilità. Definisci i tuoi impatti, crea e gestisci ogni aspetto relativo alla survey di materialità, e definisci la matrice di materialità."
    ></app-titolo-subtitolo>
  </div>
  <app-lista-tabellare
    #tabella
    [fnCaricamentoDati]="fnCaricamentoDati"
    [colonne]="colonne"
    [maxNrButton]="1"
    [filtri]="filtri"
    (bottoniListaClick)="bottoniListaClick($event)"
  >
    <div btnEnd>
      <button
        mat-flat-button
        class="primary-button"
        color="primary"
        (click)="creaNuovo()"
        *ngIf="this.utenteService.isPermessoAttivo('CREATE_MATERIALITA')"
      >
        Nuovo
      </button>
    </div>
  </app-lista-tabellare>
</div>
